import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withViewTransitions, withHashLocation } from '@angular/router';
import { appRoutes } from './app.routes';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { StateManagementService } from './core/services/state-management.service';
import { RealtimeService } from './core/services/realtime.service';
import { IntegrationService } from './core/services/integration.service';
import { CacheService } from './core/services/cache.service';
import { PerformanceService } from './core/services/performance.service';
import { OfflineService } from './core/services/offline.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(
      withInterceptors([JwtInterceptor, ErrorInterceptor])
    ),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withViewTransitions({
        skipInitialTransition: true,
      }),
      withHashLocation()
    ),
    StateManagementService,
    RealtimeService,
    IntegrationService,
    CacheService,
    PerformanceService,
    OfflineService,
    // Initialize services on app start
    {
      provide: 'APP_INITIALIZER',
      useFactory: (
        stateService: StateManagementService,
        realtimeService: RealtimeService,
        integrationService: IntegrationService,
        performanceService: PerformanceService
      ) => {
        return () => {
          stateService.initialize();
          performanceService.initialize();
          
          // Connect to realtime after authentication check
          const token = localStorage.getItem('mis-auth');
          if (token) {
            try {
              const parsed = JSON.parse(token);
              if (parsed.token) {
                realtimeService.connect();
              }
            } catch {
              // Ignore parse errors
            }
          }
        };
      },
      deps: [StateManagementService, RealtimeService, IntegrationService, PerformanceService],
      multi: true,
    },
  ]
};


